import {useQuery} from '@tanstack/react-query';
import {UnifyBillingApi} from 'app/components/entities/billing/unify';
import {secondsToMilliseconds} from 'app/util/timeConverter';

export function useUnifyPlan(teamId: string) {
  return useQuery({
    queryKey: ['billing', 'unify', 'plan', teamId],
    queryFn: async () => UnifyBillingApi.getPlan(teamId),
    select: (data) => data ?? undefined,
    refetchInterval: secondsToMilliseconds(60),
  });
}
